/*
hdx-patient-banner-directive.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/widgets/patient-banner/js/directive/hdx-patient-banner-directive',['jquery', 'angular', 'angular-ui'], function ($, angular) {
    'use strict';

    angular.module('headerPatientBannerModule', []).directive('hdxPatientBanner', ['$document', '$timeout', '$window', '$compile', '$interpolate', '$templateCache', function ($document,$timeout,$window, $compile,  $interpolate,$templateCache) {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                patientInfo: '=',
                errorMsg: '='
            },
            template:
            '<div class="hdx-patient-banner">' +
                '<div class="desktop">' +
                    '<div class="banner-content">' +
                        '<div class="nameContent" id="patientName" data-toggle="tooltip"  data-original-title="tooltipcontent" >'  +
                            '<span ng-if="(!errorMsg || errorMsg.length==0) && patientInfo.lastName"  class="name values child nameText" id="nameText">{{patientInfo.lastName | uppercase}}, {{patientInfo.firstName}} {{patientInfo.middleName}}</span>' +
                            '<span ng-if="(!errorMsg || errorMsg.length==0) && !patientInfo.lastName"  class="name values child nameText" id="nameText">{{patientInfo.firstName}} {{patientInfo.middleName}}</span>' +
                            '<span ng-if="(!errorMsg || errorMsg.length==0) && patientInfo.prefix"  class="values child">({{patientInfo.prefix}})</span>' +
                            '<span  ng-if="errorMsg && errorMsg.length>0" class="name values child errorText" id="errorText">'+ '{{errorMsg}}</span>' +
                        '</div>' +
                        '<br ng-if="!errorMsg || errorMsg.length==0" class="break">' +
                        '<div ng-if="!errorMsg || errorMsg.length==0"  class="child id" >' +
                            '<span class="keys">Patient&nbsp;ID: </span>' +
                            '<span id="patientId" class="values subvalues">'+ '&nbsp;{{patientInfo.id}}</span>' +
                        '</div>' +
                        '<span ng-if="!errorMsg || errorMsg.length==0"  class="tag">({{patientInfo.age}} {{patientInfo.gender}})</span>'+
                        '<span ng-if="!errorMsg || errorMsg.length==0"  class="child dob">' +
                            '<span class="keys">Born: </span>' +
                            '<span ng-if="patientInfo.age" class="values subvalues" >&nbsp; {{patientInfo.dob}} ({{patientInfo.age}}yr)</span>' +
                            '<span ng-if="!patientInfo.age" class="values subvalues" >&nbsp; {{patientInfo.dob}}</span>' +
                        '</span>' +
                        '<span ng-if="!errorMsg || errorMsg.length==0"  class="child gender" >' +
                            '<span class="keys">Gender: </span>' +
                            '<span class="values subvalues">&nbsp; {{patientInfo.gender}}</span>' +
                        '</span>' +
                    '</div>' +
                '</div>'+
                '<div class="responsive" >' +
                    '<div id="bannerResponsive" data-toggle="tooltip" data-original-title="{{patientInfo.dob}} ({{patientInfo.age}})" class="banner-content">' +
                        '<div ng-if="!errorMsg || errorMsg.length==0" class="nameContent" id="patientNameResp">' +
                            '<div ng-if="patientInfo.lastName" class="name values child">{{patientInfo.lastName | uppercase}}, {{patientInfo.firstName}} {{patientInfo.middleName}}</div>' +
                            '<div ng-if="!patientInfo.lastName" class="name values child">{{patientInfo.firstName}} {{patientInfo.middleName}}</div>' +
                            '<span ng-if="patientInfo.prefix" class="values child">({{patientInfo.prefix}})</span>' +
                        '</div>' +
                        '<div ng-if="errorMsg && errorMsg.length>0" class="nameContent" id="patientNameResp">' +
                            '<div class="name values child">{{errorMsg}}</div>' +
                        '</div>' +
                        '<br ng-if="!errorMsg || errorMsg.length==0" class="break">' +
                        '<div ng-if="!errorMsg || errorMsg.length==0"class="child idContent" id="patiendIdResp">' +
                            '<span class="keys">Patient&nbsp;ID: </span>' +
                            '<span class="values subvalues">'+ '&nbsp;{{patientInfo.id}}</span>' +
                        '</div>' +
                        '<span ng-if="(!errorMsg || errorMsg.length==0) && patientInfo.age && patientInfo.gender" class="tag" id="patientTagResp">({{patientInfo.age}} {{patientInfo.gender}})</span>'+
                        '<span ng-if="(!errorMsg || errorMsg.length==0) && patientInfo.age && !patientInfo.gender" class="tag" id="patientTagResp">({{patientInfo.age}})</span>'+
                        '<span ng-if="(!errorMsg || errorMsg.length==0) && patientInfo.gender && !patientInfo.age" class="tag" id="patientTagResp">({{patientInfo.gender}})</span>'+
                    '</div>' +
                '</div>' +
            '</div>',

            link: function (scope) {
                var namefieldWidth,nameContentWidth,rightBuffer;
                scope.checkParent = true;
                scope.closeAllTooltip = function (e){
                    if (typeof $(e.target).data('original-title') === 'undefined' && !$(e.target).parents().is('.tooltip.in')) {
                        $('[data-original-title]').tooltip('hide');
                    }
                };
                $(document).on('touchstart', scope.closeAllTooltip);
                $(window).resize(scope.closeAllTooltip);
                $(window).resize(function (){
                    scope.changeWidth();
                });
                scope.changeNameFieldWidth = function (){
                    $timeout(scope.changeWidth, 5);
                };

                scope.adjustWidthDesktop = function (){
                    if($('.hdx-patient-banner').parent().parent() && $('.hdx-patient-banner').parent().parent()[0].children && $('.hdx-patient-banner').parent().parent()[0].children[1] && scope.checkParent){
                        var bannerSiblingWidth;
                        var bannerParent = $('.hdx-patient-banner').parent().parent();
                        var bannerSibling = $('.hdx-patient-banner').parent().parent()[0].children[1].children[1];
                        if(bannerSibling.offsetWidth){
                            bannerSiblingWidth = bannerSibling.offsetWidth;
                        }else{
                            bannerSiblingWidth = 0;
                        }
                        rightBuffer = 150;
                        nameContentWidth = bannerParent[0].offsetWidth - bannerSiblingWidth - $('.id')[0].offsetWidth - $('.dob')[0].offsetWidth - $('.gender')[0].offsetWidth   - rightBuffer ;
                    } else if ($('.banner-content').length >0){
                        nameContentWidth = $('.banner-content')[0].offsetWidth - $('.id')[0].offsetWidth - $('.dob')[0].offsetWidth - $('.gender')[0].offsetWidth   - rightBuffer;
                    }
                    namefieldWidth = nameContentWidth - 43;
                    if (scope.nameLength) {
                        $('.name').css({'max-width': scope.nameLength});
                        $('.nameContent').css({'max-width': scope.nameLength + 40});
                    }
                    else {
                        $('.name').css({'max-width': namefieldWidth});
                        $('.nameContent').css({'max-width': nameContentWidth});
                    }

                };
                scope.setErrorDims=function (val){
                    if (val !== undefined)
                    {
                        scope.nameLength=1040;
                    }
                };
                scope.$watch('errorMsg', function (newValue) {
                    scope.setErrorDims(newValue);
                });
                scope.checkBannerWidth = false;
                scope.changeWidth = function () {
                    rightBuffer = 41;
                    if($('#nameText').text().length > 75)
                    {
                        if ($('.banner-content')[0].offsetWidth >= 1083 || $(window).width() > 1200 ||  scope.checkBannerWidth) {
                            rightBuffer = 40;
                        }
                        else {rightBuffer = 45;}
                    }
                    $('.name').css({'max-width': ''});
                    $('.nameContent').css({'max-width': ''});
                    if(!scope.isIpad()){
                        scope.adjustWidthDesktop();
                    }
                    else if(scope.isIpad()){
                        $('.name').css({'max-width': 225});
                        $('.nameContent').css({'max-width': 'none'});
                    }
                };
                scope.isIpad = function () {
                    return $window.innerWidth < 1025;
                };
                scope.changeNameFieldWidth();
                var getOptions = function (field){
                    var tooltipContent, tooltipTrigger;
                    if(field==='banner') {
                        tooltipContent = $templateCache.get('patientBannerTemplate.html');
                        tooltipTrigger = 'click hover';
                    }else if(field==='name'){
                        tooltipContent = $templateCache.get('patientBannerNameTemplate.html');
                        tooltipTrigger = 'hover';
                    }
                    var myTooltipContent = $compile('<div class=\'tooltip\'>' + tooltipContent+'</div>')(scope);

                    var optionsName = { template: myTooltipContent, placement: 'bottom', html: true, trigger: tooltipTrigger};
                    return optionsName;
                };

                $('#patientName').tooltip(getOptions('name'));
                $('#bannerResponsive').tooltip(getOptions('banner'));
                scope.triggerTooltip = function (e) {
                    $timeout(function () {
                        if ($('#bannerResponsive').next('div.tooltip:visible').length) {
                            $('#bannerResponsive').tooltip('hide');
                        } else {
                            $('#bannerResponsive').tooltip('show');
                        }
                    });
                    e.stopPropagation();
                };
                $('#patientNameResp').on('click', scope.triggerTooltip);
                $('#patiendIdResp').on('click', scope.triggerTooltip);
                $('#patientTagResp').on('click', scope.triggerTooltip);
                $('#patientName').tooltip('disable');

                scope.enableNameTooltip = function (){
                    if( $('.nameText') && $('.nameText')[0] && $('.nameText')[0].offsetWidth <=  $('.nameText')[0].scrollWidth){
                        $('#patientName').tooltip('enable');
                        $('#patientName').tooltip('show');
                    } else if( $('.errorText') && $('.errorText')[0] && $('.errorText')[0].offsetWidth <  $('.errorText')[0].scrollWidth){
                        $('#patientName').tooltip('enable');
                        $('#patientName').tooltip('show');
                    }else{
                        $('#patientName').tooltip('disable');
                    }
                };
                $('#patientName').on('mouseleave', function (){
                    $('#patientName').tooltip('disable');
                });
                scope.showNameTooltip = function (e){
                    e.stopPropagation();
                };
                $('#patientName').on('click',scope.showNameTooltip);
                $('#patientName').on('mouseenter', scope.enableNameTooltip);

            }
        };
    }]).run(['$templateCache', function ($templateCache) {
        $templateCache.put('patientBannerTemplate.html',
            '<div class="tooltip-arrow"></div>' +
            '<div   class="tooltip-content">' +
                '<div ng-if="!errorMsg || errorMsg.length==0"  class="field">' +
                    '<span class="key">Patient Name: </span>' +
                    '<span ng-if="patientInfo.lastName" class="value">{{patientInfo.lastName | uppercase}}, {{patientInfo.firstName}} {{patientInfo.middleName}}</span>' +
                    '<span ng-if="!patientInfo.lastName"class="value">{{patientInfo.firstName}} {{patientInfo.middleName}}</span>' +
                '</div>' +
                '<div ng-if="errorMsg && errorMsg.length>0" class="field">' +
                    '<span class="key">Error: </span>' +
                    '<span class="value">{{errorMsg}}</span>' +
                '</div>'+
                '<div ng-if="!errorMsg || errorMsg.length==0"  class="field">' +
                    '<span class="key">Patient ID: </span>' +
                    '<span class="value">{{patientInfo.id}}</span>' +
                '</div>' +
                '<div ng-if="!errorMsg || errorMsg.length==0"  class="field">' +
                    '<span class="key">Born: </span>' +
                    '<span class="value">{{patientInfo.dob}}</span>' +
                '</div>' +
                '<div ng-if="!errorMsg || errorMsg.length==0" >' +
                    '<span class="key">Gender: </span>' +
                    '<span class="value">{{patientInfo.gender}}</span>' +
                '</div>' +
            '<div>');

        $templateCache.put('patientBannerNameTemplate.html',
            '<div class="tooltip-arrow"></div>'+
            '<div   class="tooltip-content radius">' +
                '<span ng-if="!errorMsg || errorMsg.length==0"  class="key">Patient Name: </span>' +
                '<span ng-if="(!errorMsg || errorMsg.length==0) && patientInfo.lastName"  class="value">{{patientInfo.lastName | uppercase}}, {{patientInfo.firstName}} {{patientInfo.middleName}}</span>' +
                '<span ng-if="(!errorMsg || errorMsg.length==0) && !patientInfo.lastName"  class="value">{{patientInfo.firstName}} {{patientInfo.middleName}}</span>' +
                '<span ng-if="errorMsg && errorMsg.length>0"  class="key">Error: </span>' +
                '<span ng-if="errorMsg && errorMsg.length>0" class="value">{{errorMsg }}</span>' +
            '</div>'

        );
    }]);

});

